import styles from '../../styles/admin/Main.module.scss'

interface AdminContentLayoutProps {
  children: React.ReactNode
}

const AdminContentLayout = ({ children }: AdminContentLayoutProps) => {
  return <div className={styles.mainContentContainer}>{children}</div>
}

export default AdminContentLayout
